export default "__VITE_ASSET__OuD6GV$___"